import { EntityService, GlobalService } from "app/core/services";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { SearchMigratedClaimRequest } from "../model/requests/SearchMigratedClaimRequest";
import { InsuredNote } from "../model/InsuredNote";



@Injectable()
export class InsuredNoteService {
    constructor(
        private http: GlobalService,
        private entityService: EntityService
    ) { }


    search(): Observable<InsuredNote[]> {
        const url = `notes`; // GET api/notes
        return this.http
            .get(url)
            .map((res) => this.entityService.extractData<InsuredNote[]>(res))
            .map((data) => {
                return data.map((dataItem) => {
                    const note = new InsuredNote();
                    return this.entityService.copy(dataItem, note);
                });
            });
    }

    // Agregar nueva nota
    add(note: InsuredNote): Observable<InsuredNote> {
        const url = `notes`; // equivale a POST api/notes
        return this.http
            .post(url, note)
            .map((res) => this.entityService.extractData<InsuredNote>(res));
    }

}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/InsuredNote.Service.ts